module.exports = __webpack_public_path__ + "GF.png?f9cd69e821d1e7ac481fd495607ff32b";